<template>
  <div class="main main--customers">
    <div class="main__title main__title--3row">
      <h2>單元 {{ sections[0].sectionOrder }} </h2>
      <div  @click="fjfj()">完成單元
      </div>
    </div>
    <div class="courseContent">
      <div class="courseContent__image">
        <video width="100%" controls>
          <source :src="sections[0].sectionVideo" type="video/mp4">
          Your browser does not support HTML5 video.
        </video>
      </div>
      <div class="courseContent__title">
        <h3>單元名稱</h3>
        <div>{{ sections[0].sectionName }}</div>
      </div>
      <div class="courseContent__intro">
        <h3>文件下載</h3>
        <div><a class="download" :href="sections[0].sectionFile" target="_blank">按這裏
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download-cloud"><polyline points="8 17 12 21 16 17"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"></path></svg></a></div>
      </div>
    </div>

  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('@/firebaseConfig.js')

export default {
  computed: {
    ...mapState(['onlineCourse'])
  },
  created () {
    const sectionId = this.$route.path.split('/').pop()
    const courseId = this.$route.path.split('/')[this.$route.path.split('/').length - 2]
    let result = {}
    this.onlineCourse.forEach(course => {
      if (course.remedialId === courseId) {
        result = course
      }
    })
    this.hha = result
    fb.db.collection('remedialCourse').doc(courseId).collection('section').get().then(querySnapshot => {
      let customersArray = []
      querySnapshot.forEach(doc => {
        let customer = doc.data()
        customer.id = doc.id
        if (doc.id === sectionId) {
          customersArray.unshift(customer)
        }
      })
      this.sections = customersArray
    })
  },
  data () {
    return {
      reviewCourses: [
        {}, {}
      ],
      haa: {},
      sections: [],
      section: {}
    }
  },
  methods: {
    fjfj () {
      let thisName = this.$route.path.split('/')
      thisName.pop()
      const result = thisName.join('/')
      this.$router.push({ path: result })
    }
  }
}
</script>

<style lang="scss" scoped>
.download {
  background: navajowhite;
  padding: .5em;
  border-radius: 6px;
  box-shadow: 0 0 3px grey;
  font-weight: 700;
  &:hover {
    background:navy;
    color: #fff;
  }
}
.courseContent {
  font-size: 18px;
  .courseContent__image {
    max-width: 960px;
    height: auto;
    text-align: center;;
    margin: 0 auto;
  }
  .courseContent__title {
    padding: 2rem;
    h3 {
      font-size: 1.5em;
      margin-bottom: 1rem;
    }
  }
  .courseContent__intro {
    background: #f9f9f9;
    padding: 2rem;
    h3 {
      margin-bottom: 1rem;
    }
  }
  .courseContent__unit {
    padding: 2rem;
    h3 {
      margin-bottom: 1rem;
    }
    .unit-list__item {
      display: grid;
      grid-template-columns: 1fr 8fr 1fr;
      font-weight: 700;
        .grey {
          color: #333;
        }
      }
    }
}
</style>
